import React from "react";

import "./style.css";

const About = () => {
  return (
    <section id="Sobre" className="sobre-local-banner">
      <div className="sobre-texto">
        <h2>Sobre a Leão Truck Parts</h2>
        <p>
          Somos especializados em peças para caminhões, atendendo
          transportadoras, frotistas e caminhoneiros de todo o Brasil. Com mais
          de 2 anos de mercado, oferecemos produtos de qualidade com atendimento
          técnico direto via WhatsApp.
        </p>
        <p>
          Nosso compromisso é entregar a peça certa no menor tempo possível, com
          suporte e confiança de quem realmente entende de estrada.
        </p>
        <p className="sobre-endereco">
          Loja física: Av. José Alves Nendo, 278 - Maringá, PR
        </p>
      </div>

      <div Id="Local" className="sobre-mapa">
        <iframe
          title="Localização"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3660.081820537236!2d-51.918648923901976!3d-23.457512957786605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ecda0cd19cb847%3A0x4f527a1bdbf190b8!2sAv.%20Jos%C3%A9%20Alves%20Nendo%2C%20278%20-%20Jardim%20Catedral%2C%20Maring%C3%A1%20-%20PR%2C%2087045-260!5e0!3m2!1spt-BR!2sbr!4v1760928795388!5m2!1spt-BR!2sbr"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
};

export default About;
